export enum BindingType {
  NoBinding = 'NoBinding',
  AnnualBinding = 'AnnualBinding',
}
